import React, { memo } from 'react'

import { VerticalTabBoxV2, VerticalTabsWrapperV2 } from '../../styled'

// Sticky rail of icon + label boxes used as sub-navigation next to a content panel.
// `items`: [{ id, label, icon }] — `onChange` receives the whole item.
const VerticalTabsV2 = memo(({ items = [], activeId, onChange, width, top, ...props }) => {
	return (
		<VerticalTabsWrapperV2 $width={width} $top={top} {...props}>
			{items.map((item) => (
				<VerticalTabBoxV2 key={item.id} type='button' $active={item.id === activeId} onClick={() => onChange?.(item)}>
					{item.icon}
					<span>{item.label}</span>
				</VerticalTabBoxV2>
			))}
		</VerticalTabsWrapperV2>
	)
})

export default VerticalTabsV2
